import React from "react";

export default function ToggleControl({tabs, activeTab, setActiveTab, onTabChange}) {

  return (
    <div style ={{width: "100%", display:"flex", justifyContent: "center", marginBottom: "50px"}}>
      <div
        style={{
          display: "flex",
          borderRadius: "9999px",
          background: "white",
          padding: "7px 8px",
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.15)",
          width: "100%",
        }}
      >
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => {
              setActiveTab(tab);
              onTabChange(tab);
            }}
            style={{
              width: "25%",
              height: "42px",
              borderRadius: "9999px",
              border: "none",
              fontSize: "16px",
              fontWeight: 400,
              cursor: "pointer",
              backgroundColor: activeTab === tab ? "#6B43B5" : "transparent",
              color: activeTab === tab ? "white" : "#979797",
              transition: "all 0.2s ease",
              outline: "none",
            }}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>

  );
}
